import { render } from "./ContactBanner.vue?vue&type=template&id=5081eba5&scoped=true"
import script from "./ContactBanner.vue?vue&type=script&lang=js"
export * from "./ContactBanner.vue?vue&type=script&lang=js"

import "./ContactBanner.vue?vue&type=style&index=0&id=5081eba5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Liam\\Documents\\werowebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5081eba5"]])

export default __exports__